import React from 'react';
import { Link } from 'react-router-dom';

import { Box } from '@mui/system';

function Home() {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
        }}>
            <Box
                sx={{ width: '100%' }}
                className="call-to-action m-0">
                <div className="container-fluid">
                    <div className="call-to-action-inr">
                        <div className="overlay">
                            <Box
                                className="content ms-0"
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Box>
                                    <h2 className="heading-h2 heading m-0">
                                        Welcome to Certify Labs
                                    </h2>
                                    <h2 className='heading-h2 heading mb-3'>Smart Contract Minting</h2>
                                    <p className="desc body-m">
                                        The most user friendly way to deploy<br/>smart contracts on public blockchains
                                    </p>
                                    <h6 className='home-list-item'>- Powerful management tools</h6>
                                    <h6 className='home-list-item'>- IPFS support</h6>
                                    <h6 className='home-list-item'>- Batch Minting</h6>
                                    <h6 className='home-list-item'>- Lockable Content</h6>
                                    <h6 className='home-list-item'>- Fully Decentralized</h6>
                                    <p className='home-list-item'>
                                        Connect your wallet and join the DeFi revolution today.
                                    </p>
                                    <div className="action-otr ms-auto">
                                        <Link to="/library" className="body-sb btn-contracts">
                                            <span>View Contracts</span>
                                        </Link>
                                    </div>
                                </Box>
                                <Box sx={{
                                    width: '50%',
                                    background: 'url(./assets/img/homepage-content-image.png) center no-repeat',
                                    backgroundSize: 'contain',
                                }} />
                            </Box>
                        </div>
                    </div>
                </div>
            </Box>
        </Box>
    )
}

export default Home
